import { ReactComponent } from "/builds/mb/front/src/app/assets/images/chevron.svg?react";
import url from "/builds/mb/front/src/app/assets/images/chevron.svg?url";
export { ReactComponent };
export default url;
